import { render, staticRenderFns } from "./StartpageContainer.vue?vue&type=template&id=036efb9c"
import script from "./StartpageContainer.vue?vue&type=script&lang=js"
export * from "./StartpageContainer.vue?vue&type=script&lang=js"
import style0 from "./StartpageContainer.vue?vue&type=style&index=0&id=036efb9c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports